import { CommunicationProvider, CommunicationProviders, Concierge, Lead } from 'typings';
import { TwilioClient } from './twilio.client';
import { BandwidthClient } from './bandwidth.client';

let twilioClient: TwilioClient;
let bandwidthClient: BandwidthClient;

const getTwilioClient = (): TwilioClient => {
  if (!twilioClient) {
    twilioClient = new TwilioClient();
  }

  return twilioClient;
};

const getBandwidthClient = (): BandwidthClient => {
  if (!bandwidthClient) {
    bandwidthClient = new BandwidthClient();
  }

  return bandwidthClient;
};

export const getCommunicationService = (
  communicationProvider: CommunicationProvider
): TwilioClient | BandwidthClient => {
  if (communicationProvider === CommunicationProviders.TWILIO) {
    return getTwilioClient();
  }

  if (communicationProvider === CommunicationProviders.BANDWIDTH) {
    return getBandwidthClient();
  }

  throw new Error(`Invalid communication provider ${communicationProvider}`);
};
